export const hasTouchScreen = (): boolean => {
  return !!('ontouchstart' in window || navigator.maxTouchPoints > 0);
};
